import axios from 'axios';
import { API_URL } from '../utils/constants';

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const initiateLinkStudent = async (studentEmail: string) => {
    const response = await axios.post(
        `${API_URL}/parent/link/initiate`,
        { studentEmail },
        getHeaders()
    );
    return response.data;
};

export const verifyLinkStudent = async (studentEmail: string, otp: string) => {
    const response = await axios.post(
        `${API_URL}/parent/link/verify`,
        { studentEmail, otp },
        getHeaders()
    );
    return response.data;
};

export const getChildren = async () => {
    const response = await axios.get(
        `${API_URL}/parent/children`,
        getHeaders()
    );
    return response.data;
};

export const getParentNotifications = async (childId?: string, page: number = 1, limit: number = 15) => {
    let params = `?page=${page}&limit=${limit}`;
    if (childId) {
        params += `&childId=${childId}`;
    }
    const response = await axios.get(
        `${API_URL}/parent/notifications${params}`,
        getHeaders()
    );
    return response.data;
};

export const getChildUsageSummary = async (childId: string, days?: number) => {
    const params = days ? `?days=${days}` : '';
    const response = await axios.get(
        `${API_URL}/parent/children/${childId}/usage${params}`,
        getHeaders()
    );
    return response.data;
};

export const createChildCheckoutSession = async (childId: string, priceId: string, referralCode?: string) => {
    const response = await axios.post(
        `${API_URL}/parent/children/${childId}/subscribe`,
        { priceId, ...(referralCode ? { referralCode } : {}) },
        getHeaders()
    );
    return response.data;
};
